export const logAccessTypes = {
    loading: "LOADING_LOGACCESS",
    delete: "DELETE_LOGACCESS",
    loadedOne: "LOADED_LOGACCESS",
    loadedMultiple: "LOADED_LOGACCESSES",
    success: "SUCCESS_LOGACCESS",
};
